import React from 'react'
import { Radio, Tooltip } from 'antd'
import './index.css'

interface FormRadioButtonProps {
  label?: React.ReactNode;
  icon?: React.ReactNode;
  value?: string | number;
  radioLabelTextStyles?: React.CSSProperties;
  radioButtonStyles?: React.CSSProperties;
  radioButtonContentStyle?: React.CSSProperties;
  id?: string;
  onClick?: () => void;
  radioButtonLarge?: boolean;
  disabled?: boolean;
  tooltip?: { title: string; placement?: string };
}

const FormRadioButton: React.FC<FormRadioButtonProps> = ({
  label,
  icon,
  value,
  radioLabelTextStyles = {},
  radioButtonStyles = {},
  radioButtonContentStyle = {},
  id = '',
  onClick,
  radioButtonLarge = false,
  disabled = false,
  tooltip = { title: '', placement: 'top' },
}) => {
  return (
    <Radio.Button
      className={radioButtonLarge ? 'radioButtonLarge radioButton' : 'radioButton'}
      value={value}
      onClick={onClick}
      style={radioButtonStyles}
      disabled={disabled}
    >
      <Tooltip title={tooltip.title} placement={tooltip.placement as any}>
        <div id={id} className="radioButtonContent" style={radioButtonContentStyle}>
          <div role="img" aria-label={label as string} className="radioLabelIcon">
            {icon}
          </div>
          <div className="radioLabelText" style={radioLabelTextStyles}>
            {label}
          </div>
        </div>
      </Tooltip>
    </Radio.Button>
  )
}

export default FormRadioButton
